module.exports = __webpack_public_path__ + "media/mypage/images/special/003-fdfa8eb0de6e399f20afbbe1fa669d7e.jpg";